{
  "network": {
    "unexpected": "Անսպասելի սխալ է տեղի ունեցել: Խնդրում ենք կրկին փորձել:",
    "connectionFailed": "Կապը ձախողվեց: Ստուգեք ձեր ցանցը:",
    "timeout": "Հարցման ժամկետը լրացել է: Խնդրում ենք կրկին փորձել:"
  },
  "auth": {
    "invalidCredentials": "Սխալ տվյալներ: Ստուգեք էլ. հասցեն և գաղտնաբառը:",
    "accountInactive": "Ձեր հաշիվը ոչ ակտիվ է: Դիմեք ձեր ադմինիստրատորին:",
    "sessionExpired": "Նստաշրջանի ժամկետը լրացել է: Մուտք գործեք կրկին:"
  },
  "validation": {
    "required": "Այս դաշտը պարտադիր է:",
    "emailInvalid": "Խնդրում ենք մուտքագրել վավեր էլ. հասցե:",
    "passwordTooShort": "Գաղտնաբառը պետք է լինի առնվազն 8 նիշ:",
    "passwordMismatch": "Գաղտնաբառերը չեն համընկնում:"
  },
  "actions": {
    "saveFailed": "Չհաջողվեց պահպանել: Խնդրում ենք կրկին փորձել:",
    "deleteFailed": "Չհաջողվեց ջնջել: Խնդրում ենք կրկին փորձել:",
    "loadFailed": "Չհաջողվեց բեռնել տվյալները: Խնդրում ենք կրկին փորձել:",
    "exportFailed": "Չհաջողվեց արտահանել: Խնդրում ենք կրկին փորձել:",
    "importFailed": "Չհաջողվեց ներմուծել: Խնդրում ենք կրկին փորձել:",
    "uploadFailed": "Չհաջողվեց բեռնել ֆայլը: Խնդրում ենք կրկին փորձել:",
    "copyFailed": "Չհաջողվեց պատճենել սեղմատախտակին:",
    "resetFailed": "Չհաջողվեց վերականգնել: Խնդրում ենք կրկին փորձել:",
    "approveFailed": "Չհաջողվեց հաստատել: Խնդրում ենք կրկին փորձել:",
    "rejectFailed": "Չհաջողվեց մերժել: Խնդրում ենք կրկին փորձել:"
  }
}
